<template>
  <div class="user-info">
    <van-popup
      v-model="popupShow"
      :close-on-popstate="true"
      :close-on-click-overlay="false"
      :close-icon="require('@/assets/images/icon-close.png')"
      :closeable="true"
      @closed="closeTipPop"
    >
      <van-form
        @submit="onSubmit"
        :show-error="false"
        label-width="0"
        ref="infoform"
        class="py-4 form"
      >
        <div class="mt-8 fs-4-8 bold lh-1-8"><span v-if="!isvote">投票成功，</span>请填写个人信息以领取特惠购书券。</div>
        <van-field
          class="mt-6-6 mb-5 input-style"
          v-model="name"
          name="name"
          placeholder="请输入您的姓名"
          :border="false"
          :rules="[{ required: true, message: '请输入您的姓名' }]"
        />
        <van-field
          class="mt-6-6 input-style"
          v-model="phone"
          name="phone"
          placeholder="请输入您的手机号码"
          :border="false"
          type="number"
          :rules="[{ required: true, message: '请填写手机号码' },{pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/, message: '请填写正确的手机号码'}]"
        />
        <div class="tip mt-6-6 mb-8">*个人信息仅用于兑奖使用，本次活动承诺将对您的个人信息严格保密。如因个人信息未填写或填写有误导致无法兑奖，主办方不承担相关责任。</div>

        <van-button
          block
          type="info"
          native-type="submit"
          :disabled="loading"
          :loading="loading"
          loading-text="确定中"
        >确定</van-button>
      </van-form>
    </van-popup>

    <van-popup
      v-model="successShow"
      :close-on-popstate="true"
      :close-on-click-overlay="false"
      :close-icon="require('@/assets/images/icon-close.png')"
      :closeable="true"
      @closed="closeSuccessTip"
    >
      <div class="mt-8 mb-8 t-center bold fs-4-8 color-red">恭喜你领取成功！</div>
      <router-link
        to="/ticket"
        @click.native="successShow=false"
      >
        <van-button
          block
          type="info"
        >查看我的购书券</van-button>
      </router-link>
    </van-popup>
  </div>
</template>

<script>
import { setUserInfo } from '@/api'
import { Form, Field, Popup, Button } from 'vant'
export default {
  name: 'UserInfoForm',
  components: {
    [Popup.name]: Popup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
  },
  props: {
    formshow: {
      type: Number,
      default: 0
    },
    // 是否已投票
    isvote: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      popupShow: false,
      name: '',
      phone: '',
      loading: false,
      successShow: false
    }
  },
  watch: {
    // 数值有变显示表单
    formshow() {
      this.popupShow = true
    }
  },
  created() {
    if (this.formshow) {
      this.popupShow = true
    }
  },
  methods: {
    onSubmit(value) {
      this.loading = true
      setUserInfo(value).then(() => {
        this.loading = false
        this.popupShow = false
        this.successShow = true
      }).catch(() => {
        this.loading = false
      })
    },
    closeTipPop() {
      this.resetForm()
    },
    closeSuccessTip() {
      this.$emit("closetip")
    },
    resetForm() {
      this.$refs.infoform.resetValidation()
      this.name = ''
      this.phone = ''
    }
  }
}
</script>
<style>
.color-red {
  color: #e60012;
}
.van-field__control::-webkit-input-placeholder {
  color: #000;
}
.van-field__control::-moz-input-placeholder {
  color: #000;
}
.van-field__control::-ms-input-placeholder {
  color: #000;
}
.user-info .tip {
  font-size: 3.5vw;
  color: #333;
}
</style>